import { AxiosPromise } from 'axios';
import Project from 'Models/Project';
import { getAxiosInstance } from 'Utils/Http/ApiManager';
import { ApiUrl, getApiUrl } from 'Utils/Http/ApiUrls';

const getProjectRequest = (token: string | null, projectId: number): AxiosPromise<Project> => {
	const url = getApiUrl(ApiUrl.ProjectsProject).replace(':projectId', projectId.toString());
	const axiosInstance = getAxiosInstance(token);
	return axiosInstance.get<Project>(url);
};

export default getProjectRequest;
